import type { ComponentType, ReactNode } from "react";
import { useEffect, useState } from "react";

import { LoaderListBulletsWrapper } from "pro-features/components/Loaders/src/LoaderListItems";
import { GhostLoader } from "app/components/React/Table/SWReactTableGhostLoader";
import { i18nFilter } from "app/filters/i18nFilter";

const i18n = i18nFilter();

const constants = {
    secondLoaderTitle: "common.loaders.long.loader.title",
    secondLoaderSubTitle: "common.loaders.long.loader.subtitle",
    timeBetweenFirstAndSecondLoaders: 5000,
};

const DefaultFirstLoader = () => <GhostLoader />;
const DefaultSecondLoader = () => (
    <LoaderListBulletsWrapper
        title={i18n(constants.secondLoaderTitle)}
        subtitle={i18n(constants.secondLoaderSubTitle)}
    />
);

interface ISecondLoaderProps {
    subtitle: ReactNode;
    title: ReactNode;
}

interface ILongLoaderAfterFewSecondsProps extends Partial<ISecondLoaderProps> {
    FirstLoader?: ComponentType;
    SecondLoader?: ComponentType<ISecondLoaderProps>;
    timeBetweenFirstAndSecondLoaders?: number;
}

export const LongLoaderAfterFewSeconds = (props: ILongLoaderAfterFewSecondsProps) => {
    const {
        FirstLoader = DefaultFirstLoader,
        SecondLoader = DefaultSecondLoader,
        subtitle = i18n(constants.secondLoaderSubTitle),
        timeBetweenFirstAndSecondLoaders = constants.timeBetweenFirstAndSecondLoaders,
        title = i18n(constants.secondLoaderTitle),
    } = props;
    const [isFirstLoader, setIsFirstLoader] = useState(true);

    useEffect(() => {
        const setTimeoutRef = setTimeout(() => setIsFirstLoader(false), timeBetweenFirstAndSecondLoaders);

        return () => clearTimeout(setTimeoutRef);
    }, [timeBetweenFirstAndSecondLoaders, setIsFirstLoader]);

    return isFirstLoader ? (
        <FirstLoader />
    ) : (
        <SecondLoader
            title={title}
            subtitle={subtitle}
        />
    );
};
